module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/polly-2016-06-10.paginators.json
// module id = 1002
// module chunks = 0